import React, { useMemo } from 'react';
import BodyClassName from 'react-body-classname';
import type Loadable from 'react-loadable';
import { useSelector } from 'react-redux';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { Props as themeProps } from '@swf/themes/index';
import { getTheme } from '@swf/themes/index';

export const ThemeContext = React.createContext<{ darkClassName?: string }>({});

interface Props {
  theme?: React.ComponentType<themeProps> & Loadable.LoadableComponent;
}

const ThemeProvider: React.FC<Props> = ({ children, theme }) => {
  const isSiteUS = useSelector(select.site.isSiteUS);
  const siteId = useSelector(select.site.getId);
  const brand = useSelector(select.site.getBrand);
  const site = useSelector(select.site.getId);
  const region = useSelector(select.site.getRegion);
  const skyBetSports = useFeature(FeatureFlag.SkyBetSports);

  const Theme = useMemo(
    () => theme || getTheme({ isSiteUS, siteId, brand, site, region, skyBetSports }),
    [theme, isSiteUS, siteId, brand, site, region, skyBetSports]
  );

  return (
    <Theme>
      {(themeClassName: string, darkClassName?: string) => (
        <ThemeContext.Provider value={{ darkClassName }}>
          <BodyClassName className={themeClassName}>{children}</BodyClassName>
        </ThemeContext.Provider>
      )}
    </Theme>
  );
};

export default ThemeProvider;
